<script lang="ts">
  import type { Episode, Contributions } from "$types";
  import { dev } from "$app/environment";
  import { test_social_share_images } from "$config";
  import { PUBLIC_PROJECT } from "$env/static/public";
  import { episodeDate } from "$lib/dates";

  export let episode: Episode;
  export let contribution: Contributions | undefined;
  export let id: string;
  export let is_discussion: boolean = false;

  // if last of name is s, add an '
  let name = contribution?.name;
  if (name && name.slice(-1) === "s") {
    name += "'";
  } else if (name) {
    name = name + "'s";
  } else {
    name = "Craft Roulette";
  }

  let description = contribution?.description;
  if (!description && episode.date) {
    description = `${name} Episode #${episode.episode_number} contribution submitted on ${episodeDate(episode.date)}.`;
  }
  export let title: string = `${name} Ep. #${episode.episode_number} Contribution`;

  // Extract strings from the episode to build a custom title
  let project: string = "";
  let colors: string = "";
  let element: string = "";
  let random: string = "";

  if (episode?.project && episode?.project.length > 0) {
    project = episode.project[0].projects.name ?? "";
  }

  if (episode?.colors && episode?.colors.length > 0) {
    colors = episode.colors[0].colors.name ?? "";
  }

  if (episode?.element && episode?.element.length > 0) {
    element = episode.element[0].elements.name ?? "";
  }

  if (episode?.random && episode?.random.length > 0) {
    random = episode.random[0].randoms.name ?? "";
  }

  if (project !== "") {
    title += ` - ${project}`;
  }

  if (colors !== "") {
    title += ` - ${colors}`;
  }

  if (element !== "") {
    title += ` - ${element}`;
  }

  if (random !== "") {
    title += ` - ${random}`;
  }

  const siteName: string = "CraftRoulette.live";
  let url_string: string = `${PUBLIC_PROJECT}/episodes/episode-${episode.episode_number}/gallery/${id}`;

  if (is_discussion) {
    title = `Discussion - ${title}`;
    url_string = `${PUBLIC_PROJECT}/episodes/episode-${episode.episode_number}/gallery/${id}?comments=true`;
  }

  const params = [`n=${episode.episode_number}`, `i=${id}`];
  let image_url: string = `${PUBLIC_PROJECT}/api/images/social/contribution?${params.join("&")}`;
</script>

<svelte:head>
  <title>{title} - Craft Roulette</title>
  <meta name="robots" content="all" />
  <meta name="title" content="{title} - {siteName}" />
  <meta name="description" content={description} />

  <meta property="og:type" content="website" />
  <meta property="og:url" content={url_string} />
  <meta property="og:title" content="{title} - {siteName}" />
  <meta property="og:description" content={description} />

  <meta property="twitter:card" content="summary_large_image" />
  <meta property="twitter:url" content={url_string} />
  <meta property="twitter:title" content="{title} - {siteName}" />
  <meta property="twitter:description" content={description} />

  <meta property="twitter:image" content={image_url} />
  <meta property="og:image" content={image_url} />

  <link rel="canonical" href={url_string} />
</svelte:head>

{#if test_social_share_images && dev}
  <div class="tester">
    <img src={image_url} alt="test social share graph" />
  </div>
{/if}

<style>
.tester {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  width: 600px;
  height: auto;
  z-index: 1000;
}
.tester img {
  width: 100%;
  height: auto;
  border: 1px solid #333;
  border-radius: 5px;
}
</style>
